import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { protectedResources } from '../auth-config';
import Swal from 'sweetalert2';
import { Data } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class MRegistrationService {
    url = protectedResources.starhealthapi.endpoint;
    constructor(private http: HttpClient) { }

  getAllMRegist(search: string, order: string, page: number, max: number) {
    return this.http.get<any>(`${this.url}/MRegistration/getMedicalRegistration?search=${search}&order=${order}&page=${page}&max=${max}`)
      .pipe(
        map((res: any) => {
          return res;
        }));
  }

  getEmpMRegist(search: string, order: string, page: number, max: number, periodYear: number = 0) {
    return this.http.get<any>(`${this.url}/MRegistration/getEmpMedicalRegistration?search=${search}&order=${order}&page=${page}&max=${max}&periodYear=${periodYear}`)
      .pipe(
        map((res: any) => {
          return res;
        }));
  }

  getEmpPeriodYears() {
    return this.http.get<number[]>(`${this.url}/MRegistration/getEmpPeriodYears`);
  }

  addForm(model: any) {
    return this.http.post<any>(`${this.url}/MRegistration/addRegForm`, model)
      .pipe(
        map((res: any) => {
          return res;
        }));
  }

  downloadMRegist(search: string) {
    const object: Object = {
      'search': search
    }
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
  });

    return this.http.post(`${this.url}/MRegistration/downloadExcel?search=` + search, object, { headers: headers, responseType: 'blob' })
      .pipe(
        map((res: any) => {
          return res;
        }));
  }

  getAppSetting(key: string) {
    return this.http.get<any>(`${this.url}/MRegistration/getSetting/${key}`)
      .pipe(map(res => res));
  }
}
